import React from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';
import AdminLayout from './AdminLayout';
import PaywallLayout from './PaywallLayout';

const SubscriptionAwareLayout = ({ children }) => {
  const { isActive } = useSubscription();

  if (isActive()) {
    return <AdminLayout>{children}</AdminLayout>;
  }

  return <PaywallLayout>{children}</PaywallLayout>;
};

export default SubscriptionAwareLayout;
